package com.merkost.handpass.admin.contract

import com.merkost.handpass.api.dto.admin.FeatureFlagDto
import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

data class FeatureFlagsState(
    val flags: AsyncSection<List<FeatureFlagDto>> = AsyncSection.Loading,
    val pendingKeys: Set<String> = emptySet(),
) : MVIState

sealed interface FeatureFlagsIntent : MVIIntent {
    data object Refresh : FeatureFlagsIntent
    data class ReactToFocusTick(val tick: Long) : FeatureFlagsIntent
    data class Toggle(val key: String, val enabled: Boolean) : FeatureFlagsIntent
}

sealed interface FeatureFlagsAction : MVIAction {
    data class Navigate(val path: String) : FeatureFlagsAction
}
